<template>
	<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M15 70L10 7.5H70L65 70L40 77.5L15 70Z" fill="#E44D26" />
		<path d="M65 12.5H40V73.75L60 67.5L65 12.5Z" fill="#F16529" />
		<path
			d="M23.75 43.75L21.25 20H60L58.75 27.5H28.75L30 36.25H57.5L55 60L40 65L25 60L23.75 47.5H31.25L32.5 53.75L40 56.25L47.5 53.75L48.75 43.75H23.75Z"
			fill="white" />
	</svg>

</template>